/** Arabic-Indic (٠-٩) and Eastern Arabic-Indic (۰-۹) digits typed on Arabic keyboards -> ASCII. */
export function asciiDigits(s: string): string {
  return s.replace(/[٠-٩۰-۹]/g, (d) => String((d.charCodeAt(0) & 0xf) % 10));
}
